import { useEffect, useState } from "react";
import api from "../api";
import { Link } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import Toast from "./Toast";

export default function BannerList({ onLogout }) {
  const [banners, setBanners] = useState([]);
  const [toast, setToast] = useState(null);

  const fetchBanners = async () => {
    try {
      const res = await api.get("/banners.php");
      setBanners(res.data);
    } catch (err) {
      setToast({ message: "Failed to fetch banners", type: "error" });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete?")) return;
    try {
      const res = await api.get(`/delete_banner.php?id=${id}`);
      if (res.data.success) {
        fetchBanners();
        setToast({ message: "Banner deleted successfully", type: "success" });
      } else {
        setToast({ message: res.data.message, type: "error" });
      }
    } catch (err) {
      setToast({ message: "Server error", type: "error" });
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  return (
    <>
      <AdminNavbar onLogout={onLogout} />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Banners</h2>
          <Link to="/admin/banners/add" className="btn btn-primary">
            Add New Banner
          </Link>
        </div>
        <table className="table table-bordered table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Description</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {banners.map((b) => (
              <tr key={b.id}>
                <td>{b.id}</td>
                <td>{b.title}</td>
                <td>{b.description}</td>
                <td>
                  <img
                    src={`https://himalayanbuilders.co.in/himalayan-backend/uploads/${b.image_url}`}
                    alt={b.title}
                    width="100"
                    className="img-thumbnail"
                  />
                </td>
                <td>
                  <Link
                    to={`/admin/banners/edit/${b.id}`}
                    className="btn btn-primary btn-sm me-2"
                  >
                    Edit
                  </Link>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(b.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
}
